import { useEffect, useState } from "react";

import tailwindConfig from "../../tailwind.config";

export const useIsMobile = (): boolean => {
  const mobileBreakpoint = tailwindConfig.theme.screens.lg;
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = `(max-width: ${mobileBreakpoint})`;
    const media = window.matchMedia(mediaQuery);
    if (media.matches !== isMobile) {
      setIsMobile(media.matches);
    }
    const listener = () => setIsMobile(media.matches);
    media.addEventListener("change", listener);
    return () => media.removeEventListener("change", listener);
  }, [isMobile, mobileBreakpoint]);

  return isMobile;
};
